// extracted by mini-css-extract-plugin
module.exports = {"addPracticeProblemCategoryButtonContainer":"AddPracticeProblemCategoryButton_addPracticeProblemCategoryButtonContainer__452Oe"};